import * as svg from "../../../assets/clock-three.svg";

import {iconBuilder} from "./iconBuilder";

export const ClockThreeIcon = iconBuilder(svg, "ClockThreeIcon", "0 0 16 16");
